import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend as RechartsLegend, ResponsiveContainer } from "recharts";
import { Typography, Grid } from "@material-ui/core";
import useStyles from "./styles";

const GrantAlocated = ({ data, cx, cy, innerRadius, outerRadius, colors }) => {
  const classes = useStyles();

  // Calculate the total spent donation
  const totalSpentDonation = data.reduce((acc, entry) => acc + entry.SpentDonation, 0);
  const formatCurrency = (value) => {
    if (typeof value !== 'number' || isNaN(value)) {
        return '';
    }

    if (value >= 1000) {
        return `$${(value / 1000).toFixed(1)}k`;
    }

    return `$${value}`;
};

  return (
    <Grid container>
      <Grid item xs={10}>
        <ResponsiveContainer width="100%" height={420}>
          <PieChart className={classes.PaiChart}>
            <Pie
              data={data}
              cx="60%"
              cy="50%"
              innerRadius={innerRadius}
              outerRadius={outerRadius}
              paddingAngle={1}
              dataKey="SpentDonation"
              label
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value, name) => [`${name}: $${value}`]}
            />
            <text x="60%" y="50%" textAnchor="middle" fontSize="20" fill="#000000" className={classes.Balance}>
              <tspan dy="0" className={'BalancePrice'}>
              {formatCurrency(totalSpentDonation)}
              </tspan>
              <tspan x="60%" dy="1.7em" className={'BalanceText'}>
                Total Grant Allocated
              </tspan>
            </text>
          </PieChart>
        </ResponsiveContainer>
      </Grid>
      <Grid item xs={12}>
        <RechartsLegend
          align="left"
          verticalAlign="middle"
          layout="vertical"
          wrapperStyle={{ paddingLeft: "20px" }}
        />
      </Grid>
    </Grid>
  );
};

export default GrantAlocated;
